<template>
  <div class="about">
    <h1 @click.ctrl.exact="enableExtraOptions" @click.exact="knock">Infra app</h1>
    <p>
      Deze applicatie is ontwikkeld door
      <a href="https://wechangedit.nl">wechangedit</a>,
      in opdracht van brouwers infra.
    </p>
    <expert-options v-if="extraOptionsEnabled"/>
  </div>
</template>
<script>
import ExpertOptions from "@/components/ExpertOptions";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    extraOptionsEnabled: false,
    knocks: 0
  }),
  components: {
    ExpertOptions
  },
  computed: {
    ...mapGetters(["isExpert"])
  },
  methods: {
    enableExtraOptions() {
      this.extraOptionsEnabled = this.isExpert;
    },
    knock() {
      this.knocks++;
      if (this.knocks === 3) this.extraOptionsEnabled = this.isExpert;
    }
  }
};
</script>